module.exports = __webpack_public_path__ + "img/home-arch-mob.4f88fc94.jpg";